export const buildCanonicalUrl = (path, locale) => {
  const baseUrl = (process.env.NEXT_PUBLIC_WEBSITE_URL || "").replace(/\/+$/, "");
  const langPrefix = locale === "ar" ? "" : "/en";

  if (!path || path === "/") {
    return `${baseUrl}${langPrefix}`;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${baseUrl}${langPrefix}${normalizedPath}`;
};
